import {roles} from "@/Enums";
import type {AuthorizedActions} from "@/authorization";

const operatorDataPolicies: AuthorizedActions = {
  read: [
      roles.Administrator,
      roles.Hauptbenutzer,
      roles.Benutzer,
      roles.BenutzerFinanz
    ],
  edit: [
    roles.Hauptbenutzer,
    roles.Administrator
  ],
  download: undefined
}

export {
  operatorDataPolicies
}
